<!-- Sidebar Mask -->
<div class="overlay-mask md:hidden lg:hidden"
  [ngClass]="{'overlay-mask-open' :(sidebarMaskVisible()), 'overlay-mask' : (!sidebarMaskVisible())}"
  (click)="toggleSidebarMask()">
</div>
<div id="app-main" class="min-h-screen flex relative surface-0">
  <!-- Sidebar -->
  <div id="app-sidebar" class="app-sidebar h-screen hidden md:block lg:block flex-shrink-0 
       absolute md:static lg:static left-0 top-0 z-4 border-right-1 surface-border select-none"
    [style]="{'width': '280px'}">
    <div id="sidebar-menu" class="flex flex-column h-full overflow-hidden">
      <!-- Sidebar content -->
      <div id="sidebar-header" class="flex align-items-center px-4 flex-shrink-0 border-bottom-1" style="height: 50px">
        <div class="flex flex-row w-full justify-content-between">
          <div>Navigate</div>
          <a pStyleClass="#app-sidebar" enterFromClass="hidden" enterActiveClass="fadeinleft" leaveToClass="hidden"
            leaveActiveClass="fadeoutleft" hideOnOutsideClick="true" (click)="toggleSidebarMask()"
            class="p-ripple p-element cursor-pointer inline-flex align-items-center justify-content-center md:hidden lg:hidden text-700 mr-3"><i
              class="pi pi-times"></i></a>
        </div>
      </div>
      <!-- Sidebar Nav Menu -->
      <div class="flex h-full pb-4 overflow-auto">
        <div class="lg:hidden md:hidden w-full" pStyleClass="#app-sidebar" leaveToClass="hidden" leaveActiveClass="fadeout">
          <app-nav-menu></app-nav-menu>
          <div id="sidebar-footer" class="sidenav-footer">
            <div>Allied Pilots Association</div>
            <div class="footer-version">Version: {{version}}</div>
          </div>
        </div>
        <div class="hidden lg:block md:block w-full">
          <div class="flex flex-column h-full">
            <app-nav-menu></app-nav-menu>
            <div id="sidebar-footer" class="sidenav-footer">
              <div>Allied Pilots Association</div>
              <div class="footer-version">Version: {{version}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Details View -->
  <div id="app-details" class="flex flex-column flex-grow-1 overflow-hidden">
    <!-- topbar -->
    <div #topbar id="topbar" class="flex flex-row flex-shrink-0 justify-content-between md:justify-content-between 
         lg:justify-content-between align-items-center px-3 border-bottom-1 surface-border lg:static overflow-hidden"
      style="height: 50px;">

      <div class="container-menu-btn">
        <a pStyleClass="#app-sidebar" enterFromClass="hidden" enterActiveClass="fadeinleft" leaveToClass="hidden"
          leaveActiveClass="fadeoutleft" hideOnOutsideClick="true" (click)="toggleSidebarMask()"
          class="p-ripple p-element cursor-pointer inline-flex align-items-center justify-content-center md:hidden lg:hidden text-700"
          [style]="{'width': '34px', 'height': '34px'}">
          @if (navSignalsService.badgeCountActive$()) {
          <i class="pi pi-bars text-lg" pBadge severity="danger"></i>
          }
          @else {
            <i class="pi pi-bars text-lg"></i>
          }
        </a>
        <div class="hidden md:block lg:block" style="width:50px"></div>
      </div>

      <div class="title">{{navSignalsService.topBarTitle$()}}</div>
      <!-- If Admin Emulator overlay button -->
      @if(signalService.isEumulatingEmpNumActive$()) {
      <button class="admin-button" (click)="op.toggle($event); getEmulatedPilotInfo()">
        <i class="admin-icon pi pi-user text-2xl" style="width:34px"></i>
      </button>
      }
      @else {
      <div style="width:34px"></div>
      }
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
<!-- Overlay Popup with Admin role and emulating employee -->
<p-overlayPanel #op [dismissable]="true">
  <div class="flex flex-column gap-2" *ngIf="appService.theme$ | async as theme">
    <div class="admin-title">Emulating:</div>
    <div class="h-divider"></div>

    <div class="flex flex-row gap-2">
      <div class="flex flex-column align-items-center justify-content-center">
        <div><i class="icon-card pi pi-id-card text-2xl"></i></div>
      </div>
      <div class="flex flex-column">
        <div class="sub-title">Emplyoee #</div>
        <div class="empNum-text">{{emulatedPilot?.username}}</div>
      </div>
    </div>

    <div class="flex flex-row gap-2">
      <div class="flex flex-column align-items-center justify-content-center">
        <div><i class="icon-user pi pi-user text-2xl"></i></div>
      </div>
      <div class="flex flex-column">
        <div class="sub-title">Name</div>
        <div class="empNum-text">{{emulatedPilot?.firstName}} {{emulatedPilot?.middleName}} {{emulatedPilot?.lastName}}
        </div>
      </div>
    </div>
    <button class="reset-button" (click)="resetEmulatedPilot(); op.toggle($event)" [style]="{
      'background': theme === 'light' ? 'var(--button-primary)' : 'transparent',
      'color' : theme === 'light' ? 'var(--surface-0)' : 'var(--button-primary)'}">Reset</button>
  </div>
</p-overlayPanel>